var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mini-paper-container position-absolute",class:_vm.isOpen ? 'opened' : 'closed',on:{"click":_vm.movePaper}},[_c('div',{ref:"miniPaper",staticClass:"mini-paper"})])
}
var staticRenderFns = []

export { render, staticRenderFns }